import { __assign, __rest } from "tslib";
import React from 'react';
import { cnCheckbox } from '../Checkbox';
import './Checkbox-Label.css';
export var CheckboxLabel = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React.createElement("label", __assign({ "aria-hidden": "true" }, props, { className: cnCheckbox('Label', null, [className]) }), children));
};
